export default {
  title: 'Guardar Contacto e Dados de Pagamento',
  form: {
    remember_me: {
      label: 'Crie uma conta para um checkout mais rápido em encomendas futuras.',
    },
  },
};
